'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _captcha_input = require('../../ui/input/captcha_input');

var _captcha_input2 = _interopRequireDefault(_captcha_input);

var _index = require('../../core/index');

var l = _interopRequireWildcard(_index);

var _index2 = require('../../store/index');

var _captcha = require('../captcha');

var captchaField = _interopRequireWildcard(_captcha);

var _index3 = require('../index');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Captcha = function Captcha(_ref) {
  var lock = _ref.lock,
      i18n = _ref.i18n,
      onReload = _ref.onReload;
  var lockId = l.id(lock);

  function handleChange(e) {
    (0, _index2.swap)(_index2.updateEntity, 'lock', lockId, captchaField.set, e.target.value);
  }

  var captcha = l.captcha(lock);
  var placeholder = captcha.get('type') === 'code' ? i18n.str('captchaCodeInputPlaceholder') : i18n.str('captchaMathInputPlaceholder');
  var value = (0, _index3.getFieldValue)(lock, 'captcha');
  var isValid = !(0, _index3.isFieldVisiblyInvalid)(lock, 'captcha');
  return _react2.default.createElement(_captcha_input2.default, {
    lockId: lockId,
    image: captcha.get('image'),
    placeholder: placeholder,
    isValid: isValid,
    onChange: handleChange,
    onReload: onReload,
    value: value,
    invalidHint: i18n.str('blankErrorHint')
  });
};
/* eslint-disable no-nested-ternary */


Captcha.propTypes = {
  lock: _propTypes2.default.object.isRequired,
  error: _propTypes2.default.bool,
  onReload: _propTypes2.default.func.isRequired
};
Captcha.defaultProps = {
  error: false
};
exports.default = Captcha;